export default __webpack_public_path__ + "24c1f0cb855a404fc09c8e8881b49322.png";